
export default class Clue
{
  constructor()
  {
    this._direction = ''
    this._clueNumber = 0
    this._clue = ''
    this._solution = ''
    this._selected = false
    this._cells = [] // array of cell models
  }

  get direction() { return this._direction }
  set direction(direction) { this._direction = direction }

  get clueNumber() { return this._clueNumber }
  set clueNumber(clueNumber) { this._clueNumber = clueNumber }

  get clue() { 
    if (this._clue.match(/\(([^)]+)\)/)) // if clue contains brackets already
      return this._clue
    else 
      return this._clue + ' (' + this.solution.length + ')' 
  }
  set clue(clue) { this._clue = clue }

  get solution() { return this._solution }
  set solution(solution) { this._solution = solution }

  get selected() { return this._selected }
  set selected(selected) { this._selected = Boolean(selected) }

  get cells() { return this._cells }
  set cells(cells) { this._cells = cells }

  isWordCorrect() {
    if (!this._cells.length) 
      return false
    for (let i in this._cells) {
      let cell = this._cells[i]
      if (cell.input !== cell.solution) 
        return false
    }
    return true
  }

}

